module.exports = __webpack_public_path__ + "static/img/LeonaWang.c25af77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-people/LeonaWang.jpg
// module id = n5Al
// module chunks = 0